var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 142,
    viewBox: "0 0 199 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.64353 27.7746C17.6755 19.7426 28.8444 16.7263 39.2205 18.7257C45.4427 19.9322 51.3891 22.9485 56.2152 27.7746C69.0732 40.6326 69.0732 61.4882 56.2152 74.3462L32.9293 97.632L9.64353 74.3462C-3.21451 61.4882 -3.21451 40.6326 9.64353 27.7746Z",
    fill: "#33CC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M43.7793 108.492L67.0651 131.778C79.9231 144.636 100.779 144.636 113.637 131.778L189.199 56.2151C202.057 43.3571 202.057 22.5016 189.199 9.64353C176.341 -3.21451 155.486 -3.21451 142.628 9.64353L110 42.2712L43.7793 108.492Z",
    fill: "#33CC00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightImg);
export default __webpack_public_path__ + "static/media/rightImg.832c7a05980993d3f877f2ed731d182c.svg";
export { ForwardRef as ReactComponent };